<form [formGroup]="form" (ngSubmit)="save()">
    <h1 mat-dialog-title>Escaner</h1>
    <div mat-dialog-content>
        <mat-form-field class="full-width">
            <input type="text" #scanner matInput placeholder="Seleccione un escaner" formControlName="Scanner" required [matAutocomplete]="autScanner">
            <mat-autocomplete #autScanner="matAutocomplete" [displayWith]="filterCompleteScanner.displayFn">
                <mat-option *ngFor="let scanner of filteredScannerOptions | async" [value]="scanner">
                    {{scanner.Name}}
                </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="f.Scanner.errors && f.Scanner.errors.required">
                Seleccione un escaner
            </mat-error>
        </mat-form-field>
    </div>
    <div class="clearfix">
        <div class="pull-right">
            <button mat-button type="submit">Guardar</button>
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
        </div>
    </div>
</form>
